import createIcon from '../../createIcon';

/**
 * @component @name GppGood
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkw0IDVWMTEuMDlDNCAxNi4xNCA3LjQxIDIwLjg1IDEyIDIyQzE2LjU5IDIwLjg1IDIwIDE2LjE0IDIwIDExLjA5VjVMMTIgMlpNMTAuOTQgMTUuNTRMNy40IDEyTDguODEgMTAuNTlMMTAuOTMgMTIuNzFMMTUuMTcgOC40N0wxNi41OCA5Ljg4TDEwLjk0IDE1LjU0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GppGood = createIcon('GppGood', [
  [
    'path',
    {
      d: 'M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM10.94 15.54L7.4 12L8.81 10.59L10.93 12.71L15.17 8.47L16.58 9.88L10.94 15.54Z',
      key: 'nf6hu0',
    },
  ],
]);

export default GppGood;
